Vendd.Scripts.load(function () {

    //Vendd.MessageBus.subscribe(Vendd.Product.Messages.BindControl, 'product-details-installments', function (envelope) {

    //    var $context = envelope.message.data.context,
    //        $control = $('.x-product-details-installments', $context);

    //    if ($control.length < 1) return;

    //    initInstallments($control, $context);
    //});

});

//global function - is also used in product discount details 5
function initInstallments($control, $context) {

    var control = $control.get(0);

    var model = null, $selectedInstallment, $selectedTotal, $initialInstallment;

    var dataProductPrice = $control.data('product-price');
    var dataProductPriceN = ((typeof dataProductPrice === 'number') && dataProductPrice) || parseFloat(dataProductPrice);

    if ($control.hasClass('x-product-details-installments')) {
        var state = Vendd.Product.Controller.getState();
        var productQuantity = (state.qty ? parseFloat(state.qty) : null) || 1;
    } else {
        var productQuantity = parseFloat($('.x-combo-qty-selector input[name="qty"]', $context).val()) || 1;
    }

    var productPrice = dataProductPriceN;
    var totalPrice = dataProductPriceN * productQuantity;

    var preferredPaymentMethodIds = JSON.parse($control.attr('data-preferred-payment-method-ids') || '[]');
    var productId = $control.data('product-id');
    var productVariantId = $control.data('product-variant-id');

    $('.js-show-installments-widget', $context).fancybox({
        touch: false,
        beforeShow: function () {
            initialize();
        },
        afterShow: function () { }
    });

    control.bind = function () {
        //extend model with product quantity
        if (model.PaymentPlans) {
            model.PaymentPlans.forEach(function (plan) {
                plan.ProductQuantity = productQuantity;
            });
        }

        if (model.Literals) {
            if ($control.data('tbi-info-message').length > 0) {
                model.Literals.TbiInfoMessage = $control.data('tbi-info-message');
            }
        }

        var html = Vendd.Handlebars.parse("pdInstallments_A", model);

        $control.html(html);
 
        if (model.AreInstallmentsAvailable) {
            $('.installments-box').removeClass('hidden');

        } else {
            $('.installment-tab').addClass('hidden');
        }
       
        if (!isTouch())
            $('select', $control).sSelect({ ddMaxHeight: '200px' });

        $('select', $control).each(function () {
            var $select = $(this);
            var $block = $select.closest('.installment-method-block');
            var $planInstallment = $('.js-installment-plan .installment', $block);
            var $planTotal = $('.js-installment-plan .total-cost', $block);
            var initialInstallment = $planInstallment.html();

            $select.change(function (e) {
                if (!$(this).val()) {
                    $planInstallment.html(initialInstallment);
                    $planTotal.empty();
                } else {
                    var selectedInstallment = $(this).find(":selected").data('installment');
                    var selectedTotal = $(this).find(":selected").data('total');

                    $planInstallment.html(model.Literals.InstallmentsFromText + " " + selectedInstallment + " " + model.Literals.InstallmentsPeriodText);
                    $planTotal.html(model.Literals.InstallmentsTotalText + " " + selectedTotal);
                }
            });
        });
    };

    control.checkProductQuantity = function () {
        if ($control.hasClass('x-product-details-installments')) {
            var currentState = Vendd.Product.Controller.getState();
            var currentProductQuantity = (currentState.qty ? parseFloat(currentState.qty) : null) || 1;
        } else {
            var currentProductQuantity = parseFloat($('.x-combo-qty-selector input[name="qty"]', $context).val()) || 1;
        }

        if (currentProductQuantity === productQuantity) return;

        //calculate new total price
        totalPrice = dataProductPriceN * currentProductQuantity;
        //update product quantity
        productQuantity = currentProductQuantity
        //initialize model
        model = null;
    };
    initialize();
    function initialize() {
        //check if product quantity changed
        control.checkProductQuantity();

        if (!model) {
            Vendd.MessageBus.publishAsync(control, new Vendd.Installments.Messages.GetInstallmentsData(totalPrice, productPrice, preferredPaymentMethodIds, productId, productVariantId));

            Vendd.MessageBus.subscribe(Vendd.Installments.Messages.GetInstallmentsDataSuccess, control, function (envelope) {
                model = envelope.message.data.data;
                control.bind();
            });

        } else {
            control.bind();
        }
    };

}